const getEntityId = (entity) => entity?._id || entity;

export const findPossibleProductFieldByMarket = (
	queuesOptions = [],
	marketId,
	products = [],
	field = '_id',
) =>
	queuesOptions
		.filter((option) => option.value.market === marketId)
		.map((option) => {
			const product = products.find(
				(product) => product._id === option.value.product,
			);

			return getEntityId(product[field]);
		});
